export const PATH = '/home';
export const PAGE_TITLE = 'SULA HUB';
export const PAGE_TITLE_HOME = 'Home';
export const AMBEV_FIRST_ACCESS =
    'Sua solicitação de acesso ao SulaHub foi encaminhada para o setor Mesa de Fretes, assim que o acesso for criado você receberá por e-mail o retorno.';
